import InstitutionInformation from './views/institution-information/institution-information.vue';
import SchoolCalendarAdmin from './views/school-calendar-admin/school-calendar-admin.vue';
import Preferences from './views/preferences/preferences.view.vue';
import StaffAdmin from './views/staff-admin/staff-admin.view.vue';
import StudentAdmin from './views/student-admin/student-admin.view.vue';
import MyInfo from './views/my-info/my-info.view.vue';
import SynchronizationAdmin from './views/synchronization-admin/synchronization-admin.view.vue';
import RecentActivity from './views/recent-activity/recent-activity.view.vue';
import SubstituteTeacherAdmin from './views/substitute-teacher-admin/substitute-teacher-admin.view.vue';
import { Store } from '@/core/store/core.store';
import { ClassAdminBaseRoutes } from './views/class-admin/class-admin-base.router';
import ClassAdminBaseView from './views/class-admin/class-admin-base.view.vue';
import { PRIVATE_ROUTES } from '@/app/private/private.routes';
import { ROLES } from '@/auth/enums/auth.enum';
import { RolesNotAllowGuard } from '@/auth/guards/role-not-allow.guard';
import ToolsView from '@/tools/tools.vue';
import StorageAdminView from './views/storage-admin/storage-admin.view.vue';

export const TOOLS_ROUTES = {
  HOME: {
    NAME: 'private.tools',
    PATH: 'tools',
  },
  INSTITUTION_INFORMATION: {
    NAME: 'private.tools.institutionInformation',
    PATH: 'institutionInformation'
  },
  SCHOOL_CALENDAR_ADMIN: {
    NAME: 'private.tools.schoolCalendarAdmin',
    PATH: 'schoolCalendarAdmin'
  },
  PREFERENCES: {
    NAME: 'private.tools.preferences',
    PATH: 'preferences'
  },
  STAFF_ADMIN: {
    NAME: 'private.tools.staffAdmin',
    PATH: 'staffAdmin'
  },
  STUDENT_ADMIN: {
    NAME: 'private.tools.studentAdmin',
    PATH: 'studentAdmin'
  },
  MY_INFO: {
    NAME: 'private.tools.myInfo',
    PATH: 'myInfo'
  },
  SUBSTITUTE_TEACHER_ADMIN: {
    NAME: 'private.tools.substituteTeacherAdmin',
    PATH: 'substituteTeacherAdmin'
  },
  SYNCHRONIZATION_ADMIN: {
    NAME: 'private.tools.synchronization',
    PATH: 'synchronization'
  },
  RECENT_ACTIVITY: {
    NAME: 'private.tools.recentActivity',
    PATH: 'recentActivity'
  },
  STORAGE_ADMIN: {
    NAME: 'private.tools.storageAdmin',
    PATH: 'storageAdmin'
  }
};

export const ToolsRoutes = {
  path: TOOLS_ROUTES.HOME.PATH,
  component: ToolsView,
  name: TOOLS_ROUTES.HOME.NAME,
  beforeEnter: async (to, from, next) => {
    if(Store.state.AppStore.appReady) {
        next();
    } else {
      Store.subscribe((mutation) => {
        if(mutation.type === 'AppStore/setAppReady') {
            next();
        }
      });
    }
  },
  children: [
    {
      path: '/',
      name: TOOLS_ROUTES.HOME.NAME,
      redirect: { 
        name: TOOLS_ROUTES.MY_INFO.NAME
      }
    },
    { 
      name: TOOLS_ROUTES.INSTITUTION_INFORMATION.NAME,
      path: TOOLS_ROUTES.INSTITUTION_INFORMATION.PATH,
      component: InstitutionInformation,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
    {
      name: TOOLS_ROUTES.SCHOOL_CALENDAR_ADMIN.NAME,
      path: TOOLS_ROUTES.SCHOOL_CALENDAR_ADMIN.PATH,
      component: SchoolCalendarAdmin,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
    {
      name: TOOLS_ROUTES.PREFERENCES.NAME,
      path: TOOLS_ROUTES.PREFERENCES.PATH,
      component: Preferences,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
    {
      path: 'class-admin',
      name: 'class-admin',
      component: ClassAdminBaseView,
      children: ClassAdminBaseRoutes,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
    {
      name: TOOLS_ROUTES.STAFF_ADMIN.NAME,
      path: TOOLS_ROUTES.STAFF_ADMIN.PATH,
      component: StaffAdmin,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
    {
      name: TOOLS_ROUTES.STUDENT_ADMIN.NAME,
      path: TOOLS_ROUTES.STUDENT_ADMIN.PATH,
      component: StudentAdmin,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
    {
      name: TOOLS_ROUTES.MY_INFO.NAME,
      path: TOOLS_ROUTES.MY_INFO.PATH,
      component: MyInfo
    },
    {
      name: TOOLS_ROUTES.SYNCHRONIZATION_ADMIN.NAME,
      path: TOOLS_ROUTES.SYNCHRONIZATION_ADMIN.PATH,
      component: SynchronizationAdmin
    },
    {
      name: TOOLS_ROUTES.RECENT_ACTIVITY.NAME,
      path: TOOLS_ROUTES.RECENT_ACTIVITY.PATH,
      component: RecentActivity,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
    {
      name: TOOLS_ROUTES.SUBSTITUTE_TEACHER_ADMIN.NAME,
      path: TOOLS_ROUTES.SUBSTITUTE_TEACHER_ADMIN.PATH,
      component: SubstituteTeacherAdmin,
      beforeEnter: async (to, from, next) => {
        if(Store.state.AuthStore.privileges.SubstituteTeacher) 
          next();
        else
          next({ name: PRIVATE_ROUTES.HOME.NAME });
      }
    },
    {
      name: TOOLS_ROUTES.STORAGE_ADMIN.NAME,
      path: TOOLS_ROUTES.STORAGE_ADMIN.PATH,
      component: StorageAdminView,
      beforeEnter: RolesNotAllowGuard.bind({ rolesNotAllow: [ROLES.EDUAC_AUTHOR] }),
    },
  ]
}
